import { api } from "./api";
import { SigninRequest, SigninResponse } from "Models/auth";

export const signinApi = api.injectEndpoints({
  endpoints: (build) => ({
    signin: build.mutation<SigninResponse, SigninRequest>({
      query: (params) => ({
        url: "auth/signin",
        method: "POST",
        body: params,
      }),
    }),
    googleAuth: build.mutation<SigninResponse, { idToken: string }>({
      query: (params) => ({
        url: "auth/google",
        method: "POST",
        body: params,
      }),
    }),
    signout: build.mutation<void, void>({
      query: () => ({
        url: "auth/signout",
        method: "POST",
      }),
    }),
    forgotPassword: build.mutation<void, { email: string }>({
      query: (params) => ({
        url: "auth/forgot-password",
        method: "POST",
        body: params,
      }),
    }),
    confirmForgotPassword: build.mutation<void, { email: string; confirmationCode: string; newPassword: string }>({
      query: (params) => ({
        url: "auth/confirm-forgot-password",
        method: "POST",
        body: params,
      }),
    }),
  }),
});

export const {
  useSigninMutation,
  useGoogleAuthMutation,
  useSignoutMutation,
  useForgotPasswordMutation,
  useConfirmForgotPasswordMutation,
} = signinApi;
